import { EndPtTronRentResourceRecords } from "@wallet-manager/node-types/dist/src/access/const/AccessAPIEndPoints";
import axios from "./axiosInstance";

type TronRentResourceRecordRefreshReq = {
  chainType: number | null;
  chainId: number | null;
  walletAddress: string;
};

export async function getRentResouceBatchWallet(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(EndPtTronRentResourceRecords.prefix, input);
}

export async function getTronRentResourceRecordExport(
  params: any,
  config?: any
) {
  const { pageSize, page, ...rest } = params;

  const payload = { ...rest, limit: pageSize, offset: pageSize * page };

  return await axios.get<never, any>(EndPtTronRentResourceRecords.export, {
    params: { ...payload },
    ...config,
  });
}

export async function postTronRentResourceRecordRefresh(
  params: TronRentResourceRecordRefreshReq
) {
  return await axios.post<never, any>(EndPtTronRentResourceRecords.refresh, {
    ...params,
  });
}
